import React from "react";

const Chapter6 = () => {
  return (
    <>
      <h2>
        What are the drinking water and recreational use standards for{" "}
        <em>E. coli</em>?
      </h2>
      <p>
        <em>E. coli</em> contamination is measured in colony forming units (CFU)
        per 100 mL water..
      </p>
      <ul>
        <li>
          The national drinking water standard for <em>E. coli</em> is 0 CFU/100
          mL water in most cases
        </li>
        <li>
          The natural swimming area standards in Colorado are 235 CFU/100 mL
          water
        </li>
        <li>
          The primary contact (wading and swimming) standard for many streams in
          Colorado including the South Platte River in Denver is 126 CFU/100 mL
        </li>
      </ul>
    </>
  );
};

export default Chapter6;
